import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { WaremaButton } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-empty-page-banner',
    imports: [WaremaButton, TranslatePipe, RouterModule],
    templateUrl: './empty-page-banner.component.html',
    styleUrls: ['./empty-page-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyPageBannerComponent {
    public readonly imgName = input('');
    public readonly btnTextKey = input('');
    public readonly btnIconScr = input('');
    public readonly btnRouterLink = input('');
    public readonly btnQueryParams = input({});
    public readonly btnHref = input('');
    public readonly btnTarget = input('');
    public readonly headlineKey = input('');
    public readonly descriptionKey = input('');
    public readonly descriptionAsInnerHtml = input(false);
    public readonly hideBtn = input(false);
    public readonly backgroundPosition = input('center');
}
